<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/user/getSupplierLists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="user_name">
          <Input type="text" v-model="searchData.nick_name" placeholder="微信名" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" placeholder="注册时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>
    </pageTable>

    <userDetail ref="editModel" :user_id="editUserId" @close="editUserId=0"></userDetail>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import userDetail from "./detail";
  export default {
    name: "driver",
    components:{pageTable,userDetail},
    data() {
      return {
        searchData: {
          mobile: '',
          nick_name:'',
          create_time:''
        },
        tableColumn: [
          {title: 'ID',key: 'user_id',align: "center"},
          {title: '手机号',key: 'mobile',align: "center"},
          {title: '微信名',key: 'nick_name',align: "center"},
          {title: '充值余额',key: 'promote_balance',align: "center"},
          {title: '注册时间',key: 'create_time',align: "center"},
          {title: '详情',align: "center",render:(h,params)=>{
              return h('div',[
                h('Button',
                  {
                    props: {type:'primary',size:'small'},
                    on:{
                      click:()=>{this.showDetail(params.row.user_id)}
                    },
                  },'查看')
              ])
            }},
        ],
        tableData: [],
        editUserId:0
      }
    },
    methods: {
      showDetail(user_id){
        this.editUserId = user_id
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
